import request from '../../utils/request';

export const quotationService = {
    //DC列表数据查询
    quotationInit: (data) => {
        return request({
            url: '/quotation/init',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    updateQuotationLine: (data) => {
        return request({
            url: '/quotation/save',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    quotationHistoryInit: (data) => {
        return request({
            url: '/quotation/history',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    exportDetail: (quotationId) => {
        return request({
            url: `/quotation/exportDetail/${quotationId}`,
            method: 'post',
            responseType: 'blob',
            fullResponse: true
        })
    },
}